<template>
  <div class="store-locator">
    <div class="store-locator__container">
      <div class="store-locator__header row">
        <a class="single-store__back-btn" @click="handleClick">
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.3335 28L46.6668 28M9.3335 28L23.3335 14M9.3335 28L23.3335 42"
              stroke="#B51F4F"
              stroke-width="4"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </a>
        <div class="store-locator__header-map col-9">
          <MapLocall :dataStore="dataStore" :positionSlug="positionSlug"/>
        </div>
        <div class="store-locator__header-infos col-3">
          <div class="store-locator__header-infos--list">
            <div
              v-for="(store, index) in dataStore"
              :key="index"
              class="store-locator__header-infos--list__item"
            >
              <StoreInfo :data="store" />
            </div>
            <div class="single-store__gallery">
              <div class="single-store__gallery-slider">
                <div class="single-store__gallery-slide">
                  <img
                    v-if="url_thumbnail"
                    :src="url_thumbnail"
                    data-src="https://skjewellery396.e.wpstage.net/wp-content/uploads/2019/10/2.jpg"
                    alt=""
                    class="single-store__gallery-image locate-lazy-img"
                  />
                  <img
                    :src="url_thumbnail_hover"
                    v-if="url_thumbnail_hover"
                    data-src="https://skjewellery396.e.wpstage.net/wp-content/uploads/2019/10/1.jpg"
                    alt=""
                    class="single-store__gallery-image-hover locate-lazy-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="store-locator__body">
          <div
            class="store-locator__body-seo"
            v-for="(seo, index) in dataSeos"
            :key="index"
          >
          <ListingQue
              v-if="seo.map_seo_field"
              :description="seo.map_seo_field"
              :showReadMore="false"
            />
            <LocateUsCta v-if="seo" :data="seo" />
          </div>

          <div style="padding-top: 40px" class="store-locator__body-faqs">
            <Faqs v-if="data_faqs" :data="data_faqs" :option_faqs="option_faqs" />
          </div>
        </div>
    </div>
  </div>
</template>
    
<script setup lang="ts">
import { onMounted, ref } from "vue";
import StoreLocator from "@/components/LocallUs/StoreLocator.vue";
import StoreInfo from "@/components/LocallUs/StoreInfo.vue";
import ListingQue from "~/components/Listing/ListingQue.vue";
import Faqs from "~/components/Product/SingleProduct/Faqs.vue";
import MapLocall from "~/components/LocallUs/MapLocall.vue";
import LocateUsCta from "~/components/LocallUs/LocateUsCta.vue";

const { pushToDataLayer, pushPageTypeToDataLayer } = useCustomGtm();
const runtimeConfig = useRuntimeConfig();
const { $file } = useNuxtApp();
const dataStore = ref([]);
const route = useRoute();
const router = useRouter();
const positionSlug = ref();
const slug = ref(route.params.slug);
const dataCta = ref();
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
let country = '';
if (locale.value === 'ms-my') {
  country = '/ms-my';
} else {
  country = '';
}
interface IRequest {
  success: boolean;
  data: any;
}
const style: any = {
  width: "15px",
  height: "15px",
  color: "#000",
  transform: "rotate(-90deg) translate(-1px, -1px)",
};
const isLoading = ref<boolean>(false);
const dataSeos = ref([]);
const option_faqs = ref({
  type: 1,
  style: {
    item: {
      background: "transparent",
      hoverBackground: "",
      textColor: "#212529",
      hoverColor: "",
      fontSize: "15px",
    },
    icon: {
      background: "#000",
    },
    content: {
      background: "rgba(157, 157, 157, 0.1)",
      textColor: "#212529",
      fontSize: "15px",
    },
  },
});
const list_use_banner = ref([]);
const data_faqs = ref();
const userStore = useUserStore();
const handleClick = () => {
  router.push(`${country}/locate-us/`);
};
const dataSeo = ref({});
const url_thumbnail = ref<string>("");
const url_thumbnail_hover = ref<string>("");
const handleGetData = async () => {
  try {
    isLoading.value = true;
    const response = await $file.get<IRequest>(
      "store-locator/store-locator.json",
      {
        headers: {
          Authorization: `Bearer ${userStore.csrf}`,
          'X-API-Server': userStore.csrf_server
        },
      }
    );

    if (response.success) {
      setTimeout(() => {
        isLoading.value = false;
        altLazyIO();
      }, 100);
      dataStore.value = response.data.stores;
      dataSeo.value = response.data.seo;
      let arrSeo: any = [];
      if (response.data.seo) {
        response.data.seo?.list_banner.map((item: any) => {
          if (item.main_enable === true) {
            arrSeo.push(item);
          }
        });
        dataSeos.value = arrSeo;
      }
    }
  } catch (error) {
    isLoading.value = false;
    console.error("Error fetching profile data:", error);
  }
};

const { data: response, error } = await useAsyncData<IRequest>(
  'store-locator-data',
  () =>
    $file.get('store-locator/store-locator.json', {
      headers: {
        Authorization: `Bearer ${userStore.csrf}`,
        'X-API-Server': userStore.csrf_server,
      },
    })
);
if (response?.value?.success) {
      setTimeout(() => {
        // isLoading.value = false;
        altLazyIO();
      }, 100);
      let arrSeo: any = [];
      if (response.value.data.seo) {
        response.value.data.seo?.list_banner.map((item: any) => {
          if (item.main_enable === true) {
            arrSeo.push(item);
          }
        });
        dataSeos.value = arrSeo;
      } 
    // data_faqs.value = response.value.data.faq;
    // dataStore.value = response.value.data.stores;
      dataStore.value = response.value.data.stores.filter((item: any) => {
        return item.slug === slug.value;
      });
      data_faqs.value = response.value.data.stores[0].faq;
      url_thumbnail.value = response.value.data.stores[0].store_gallery?.store_thumbnail.url ?? '';
    }

onMounted(async () => {
  await handleGetData();
  if (slug.value) {
    dataStore.value = dataStore.value.filter((item: any) => {
      return item.slug === slug.value;
    });
    positionSlug.value = {
      lat: parseFloat(dataStore.value[0].lat),
      lng: parseFloat(dataStore.value[0].lng),
    }
    if (!window.map) {
    // console.error("Google Map is not initialized yet.");
    return;
  }
  try { window.map.setZoom(15);
    window.map.setCenter(positionSlug.value);
   
    
  } catch (error) {
    // console.error("Error setting the map position:", error);
  }
    const data = dataSeo.value.list_banner.map((item) => {
      return item;
    });
    const _id =dataStore.value[0].ID
    data_faqs.value = dataStore.value[0].faq;
    url_thumbnail.value = dataStore.value[0].store_gallery?.store_thumbnail.url ?? '';
    url_thumbnail_hover.value =dataStore.value[0].store_gallery?.store_thumbnail_hover.url ?? '';
    const seo = data.find((item: any) =>
      item.posts_show.includes(Number(_id)) 
    ) 
    if (seo) {
      dataSeos.value = [seo];
    }

  }
});
const faqData = ref<any>({
  faqs_items: {},
  readMore: false,
  info_section: {
    normal: `<strong style="margin-top: 0;margin-bottom:16px;
            font-weight: 700;font-size:32px">Find Gold & Diamond Shops Near You: Over 30 Outlets In Singapore</strong> <p class="section-text">Explore our extensive collection, get expert advice from our skilled staff, and experience our exceptional customer service in any of our jewellery shops in Singapore. With more than 30 outlets across the country, SK Jewellery brings the latest offerings and new arrivals to a shop near you.</p>
            <p class="section-text">Easily find the perfect jewellery piece to symbolise your love, celebrate a milestone, or simply express your personal style. Browse our online store locator directory to find your nearest SK Jewellery outlet in Singapore and complete your shopping conveniently.</p>
           <h2 style="margin-top: 0;margin-bottom:16px;
            font-weight: 700;">Exquisite Jewellery Designs In Our Gold & Diamond Shops Near You</h2> 
            <p class="section-text">Come discover the beauty in our jewellery shop and allow us to help you find a piece of jewellery that you’ll treasure for a lifetime. Whether you’re searching for a sparkling diamond engagement ring or a thoughtful gold birthday gift, our jewellery outlets across Singapore provide a world of brilliant options, including rings, bracelets, and earrings.</p><p class="section-text">Our wide presence across the island is a testament to our commitment to bring our customers the finest selection of jewellery, right to your neighbourhoods in Singapore, such as <a>Serangoon</a>, Choa Chu Kang, and Bugis. Let us be your trusted companion in celebrating life’s most precious moments with our exquisite designs and unparalleled craftsmanship.</p>

           <h2 style="margin-top: 0;margin-bottom:16px;
            font-weight: 700;">Gold That Is As Pure As It Gets</h2> <p class="section-text">999 gold, also known as 24-karat (24k) gold, is the highest purity of
           gold commercially available. Widely coveted for its rarity and beauty,
           it is 99.9% pure and mixed with only 0.1% other metals. The deep yellow
           hue of 999 gold has long been associated with wealth, luxury, and power.
           It is the colour of the sun and stands for warmth, vitality, and wisdom.
           Whether you choose a stunning necklace or a pair of elegant earrings,
           you can be sure that your gold jewellery will stand the test of time.</p>
           `,
  },
});
onMounted( ()=>{
  const routeslug = useRoute(); // Get the current route
  const pathSegments = routeslug.path.split('/').filter(segment => segment); 
  const pageType = 'store locator'; 
  const hierachy1 = pathSegments[0] || 'n/a'; 
  const hierachy2 = pathSegments[1] || 'n/a'; 
  const hierachy3 = 'n/a';
  pushPageTypeToDataLayer(pageType, {
    hierachy1,
    hierachy2,
    hierachy3,
  });
})
</script>
    
<style scoped lang="scss" >
@import "@/assets/scss/components/locate-us/_locate_store.scss";
.store-locator__body-faqs {
  .single-product__faq-container {
    max-width: 1440px;
    .faqs__heading {
      text-align: left !important;
    }
  }
}
.single-store__back-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  height: 80px;
  width: 80px;
  background: #fbf8f8;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  z-index: 10;
  @media screen and (max-width: 520px) {
    width: 50px;
    height: 50px;
  }
}
</style>